import type { AiActionSource, AiActionStatus } from '../contracts/ai-history';
import type { ClientHistoryKind, ClientNoteSource } from '../contracts/client-notes';
import type { StatusTone } from '../contracts/common';
import type { Via } from '../enums';

/** Fala 10: notatki klienta, oś czasu klienta (zakładka „Historia”), rozmowy z Copilotem i Historia AI. */

/** Źródło notatki (widoczne przy notatce). */
export const CLIENT_NOTE_SOURCE_LABELS: Record<ClientNoteSource, string> = {
  manual: 'Ręcznie',
  copilot: 'Copilot',
  mcp: 'Claude przez MCP',
  automation: 'Automatyzacja',
};

/** Filtry osi czasu klienta. */
export const CLIENT_HISTORY_KIND_LABELS: Record<ClientHistoryKind, string> = {
  note: 'Notatki',
  change: 'Zmiany',
  mail: 'Maile',
  meeting: 'Spotkania',
  task: 'Zadania',
  time: 'Czas',
  approval: 'Akceptacje',
  agent_run: 'Przebiegi AI',
  event: 'Zdarzenia',
};

/** Kto działał zamiast osoby (kanał aktora) — podpis wpisu osi czasu. */
export const VIA_ACTOR_LABELS: Partial<Record<Via, string>> = {
  ai: 'Copilot',
  mcp: 'Claude przez MCP',
  worker: 'Automatyzacja',
  system: 'System',
};

/** Źródło działania AI (strona „Historia AI”). */
export const AI_ACTION_SOURCE_LABELS: Record<AiActionSource, string> = {
  copilot: 'Copilot',
  mcp: 'Claude przez MCP',
  automation: 'Automatyzacja',
  delegate: 'Zleć Claude',
};

export const AI_ACTION_STATUS_LABELS: Record<AiActionStatus, string> = {
  ok: 'Wykonano',
  error: 'Błąd',
  waiting_approval: 'Czeka na akceptację',
  needs_confirmation: 'Do potwierdzenia',
  needs_choice: 'Do wyboru',
};

export const AI_ACTION_STATUS_TONES: Record<AiActionStatus, StatusTone> = {
  ok: 'success',
  error: 'danger',
  waiting_approval: 'accent',
  needs_confirmation: 'warning',
  needs_choice: 'warning',
};
